<template>
  <div class="page_six">
    <div class="page_content flex-eju-center">
      <div class="one_time">
        <div style="font-size: 26px;margin-bottom:20px;">易企盈是上海克而瑞信息技术有限公司旗下</div>
        <div style="font-size: 26px;margin-bottom:20px;">房地产数字化新营销解决方案服务商</div>
        <div>它服务于新盘销售全环节搭建基于微信社交的营销平台，实现互联网低成本获客提供拓客工具包，与客户反复触达建立信任，完成线上看房，讲房，报备，确客，成交等过程，从而达到销售过程全管控，助力客户完成数字化新营销转型。</div>
      </div>
      <!-- <img
        style="margin-bottom: 36px"
        src="@/assets/svg/page_1/banner-易企盈.svg"
      />
      <vue-typed-js
        class="type_wrapper"
        :strings="[typingString]"
        :showCursor="false"
      >
        <div class="typing"></div>
      </vue-typed-js>
      <div class="content_wrapper flex-eju-center">
        <div
          class="use_btn animate__animated animate__fadeInUp"
          @click="showMask"
        >
          <div class="animate_hover">立即体验</div>
        </div>
      </div> -->
    </div>
    <div class="page_bottom animate__animated animate__fadeInUp">
      <div class="bottom_left">
        <div class="left_header">
          <div class="header_left_top flex-eju-align">
            <div class="logo_word">
              <img src="@/assets/svg/logo-white.svg" />
            </div>
            <div class="logo_tip">
              <img src="@/assets/svg/wechat-enterprise.svg" />
            </div>
          </div>
          <div class="header_left_bottom">克而瑞旗下数字化新营销解决方案</div>
        </div>
        <div class="link_list">
          <div class="friend">友情链接</div>
          <div
            class="friend_item"
            v-for="(link, index) in linkList"
            :key="index"
          >
            <a :href="link.url" target="_blank">{{ link.name }}</a>
          </div>
        </div>
        <div>地址：上海市静安区广中路788号秋实楼6楼&nbsp;&nbsp;&nbsp;&nbsp;电话：021-60868888</div>
        <div>
          上海克而瑞信息技术有限公司&nbsp;&nbsp;&nbsp;&nbsp;备案号：<img src="@/assets/img/gongan.png" style="position:relative;top: 4px;" alt=""><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602006176" target="_blank"
            >沪公网安备 31010602006176号</a
          >&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/" target="_blank"
            >沪ICP备2021006340号-1</a
          >
        </div>
      </div>
      <div class="bottom_right">
        <div
          class="right_item"
          v-for="(item, index) in qrcodeList"
          :key="index"
        >
          <div class="item_title">{{ item }}</div>
          <div class="item_content">
            <img :src="require(`@/assets/img/${item}.png`)" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VueTypedJs } from "vue-typed-js";
export default {
  props: {
    activePageIndex: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    activePageIndex: {
      handler: function (val) {
        if (val === 5) {
          this.showPage = true;
        }
      },
    },
  },
  components: {
    VueTypedJs,
  },
  data() {
    return {
      showPage: false,
      typingString: `全数据互通，数据驱动业务增长，开启营销数字化时代！`,
      linkList: [
        {
          name: "易居企业集团",
          url: "http://www.ehousechina.com/",
        },
        {
          name: "中房网",
          url: "http://www.fangchan.com/",
        },
        {
          name: "筑想科技",
          url: "http://www.wishbuild.com/",
        },
      ],
      qrcodeList: ["克而瑞", "中房网", "筑想科技"],
    };
  },
  methods: {
    showMask() {
      this.$emit("showMask");
    },
  },
};
</script>
<style lang="less" scoped>
.page_six {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: linear-gradient(107.73deg, #0174ff 0%, #5500c1 100%);
  position: relative;
  padding-top: 8%;
  &::before {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(107.73deg, #0174ff 0%, #5500c1 100%);
    background-image: url("../../../assets/svg/chart-bg.svg");
    background-size: 80%;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.1;
  }
  .one_time {
    width: 80%;
    color: #fff;
    font-size: 20px;
    line-height: 32px;
  }
  .page_content {
    height: 60%;
    flex-direction: column;
  }
  .page_bottom {
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -640px;
    height: 312px;
    width: 1280px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    border-radius: 40px;
    padding: 60px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .bottom_left {
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.7);
    white-space: nowrap;
    .logo_word {
      height: 24px;
    }
    .header_left_bottom {
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 3.5px;
      color: #fff;
      margin-top: 2px;
    }
    .logo_tip {
      height: 24px;
      margin-left: 6px;
    }
    .left_header {
      margin-bottom: 20px;
    }
    .link_list {
      display: flex;
      justify-content: flex-start;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 10px;
      .friend {
        padding-right: 6px;
      }
      .friend_item {
        margin: 0 6px;
        &::after {
          content: "|";
          margin-left: 12px;
          color: rgba(255, 255, 255, 0.7);
        }
        &:last-child::after {
          content: "";
        }
      }
    }
    a {
      color: rgba(255, 255, 255, 0.7);
      text-decoration: none;
      &:hover {
        color: #fff;
      }
    }
  }
  .bottom_right {
    display: flex;
    justify-content: flex-end;
    .right_item {
      margin-left: 80px;
    }
    .item_title {
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      text-align: center;
      margin-bottom: 12px;
    }
    .item_content {
      width: 108px;
      height: 108px;
      background: #fff;
      border-radius: 8px;
      padding: 8px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .content_wrapper {
    padding-top: 30px;
  }
  .type_wrapper {
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .typing {
    font-size: 40px;
    line-height: 56px;
    font-weight: 300;
    color: #fff;
  }
}
</style>
